/**
 * Ayuda a que el navegador ofrezca guardar credenciales tras un login SPA.
 * Complementa name/autocomplete en el formulario (requerido por Chrome, Safari, Firefox).
 */
export async function storeLoginCredential(username: string, password: string): Promise<void> {
  if (!username || !password) return;
  if (typeof window === 'undefined' || !window.isSecureContext) return;
  if (!('PasswordCredential' in window) || !navigator.credentials?.store) return;

  try {
    const CredentialCtor = (window as Window & {
      PasswordCredential: new (data: { id: string; password: string; name?: string }) => Credential;
    }).PasswordCredential;

    await navigator.credentials.store(
      new CredentialCtor({
        id: username,
        password,
        name: username,
      })
    );
  } catch {
    // El usuario puede cancelar el diálogo o el navegador no admite almacenamiento.
  }
}
